import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.handleClickOutsideBound = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutsideBound)

    // this.refreshActiveMenuBound = this.refreshActiveMenu.bind(this)
    // document.addEventListener("turbo:load", this.refreshActiveMenuBound)

    this.onDropdownShownBound = this.onDropdownShown.bind(this)
    this.onDropdownHiddenBound = this.onDropdownHidden.bind(this)
    this.repositionMenuBound = this.repositionMenu.bind(this)
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("shown.bs.dropdown", this.onDropdownShownBound)
      this.buttonTarget.addEventListener("hidden.bs.dropdown", this.onDropdownHiddenBound)
    }

    // Ensure the dropdown always opens to the right of the button
    this.configureDropdownMenu()

    // If the menu is turbo-permanent, keep active state in sync
    // this.refreshActiveMenu()
  }

  disconnect() {
    if (this.handleClickOutsideBound) {
      document.removeEventListener("click", this.handleClickOutsideBound)
    }
    // if (this.refreshActiveMenuBound) {
    //   document.removeEventListener("turbo:load", this.refreshActiveMenuBound)
    // }
    if (this.hasButtonTarget) {
      this.buttonTarget.removeEventListener("shown.bs.dropdown", this.onDropdownShownBound)
      this.buttonTarget.removeEventListener("hidden.bs.dropdown", this.onDropdownHiddenBound)
    }
    this.detachRepositionListeners()
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && this.hasMenuTarget) {
      const dropdown = this.menuTarget
      if (dropdown && dropdown.classList.contains('show')) {
        this.buttonTarget.click()
      }
    }
  }

  configureDropdownMenu() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.add("fw-create-dropdown__menu")

    this.menuTarget.style.transform = "none"
  }

  onDropdownShown() {
    this.repositionMenu()
    this.attachRepositionListeners()
  }

  onDropdownHidden() {
    this.detachRepositionListeners()
  }

  attachRepositionListeners() {
    window.addEventListener("resize", this.repositionMenuBound)
    window.addEventListener("scroll", this.repositionMenuBound, true)
  }

  detachRepositionListeners() {
    window.removeEventListener("resize", this.repositionMenuBound)
    window.removeEventListener("scroll", this.repositionMenuBound, true)
  }

  repositionMenu() {
    if (!this.hasButtonTarget || !this.hasMenuTarget) return

    const rect = this.buttonTarget.getBoundingClientRect()
    const gap = 10

    this.menuTarget.style.zIndex = "15000"
    this.menuTarget.style.position = "fixed"
    this.menuTarget.style.top = `${Math.round(rect.top)}px`

    const menuWidth = this.menuTarget.offsetWidth || 200
    let left = Math.round(rect.right + gap)
    const maxLeft = Math.max(8, window.innerWidth - menuWidth - 8)
    if (left > maxLeft) left = maxLeft
    this.menuTarget.style.left = `${left}px`

    this.menuTarget.style.right = "auto"
    this.menuTarget.style.transform = "none"
    this.menuTarget.style.marginLeft = "0"
  }

  // refreshActiveMenu() {
  //   const menuRoot = this.element
  //   if (!menuRoot) return

  //   const currentUrl = new URL(window.location.href)
  //   const currentTab = currentUrl.searchParams.get("tab") || "dashboard"
  //   const currentPath = currentUrl.pathname

  //   const items = menuRoot.querySelectorAll(".fw-menu__item")
  //   items.forEach((li) => li.classList.remove("fw-menu__item--active"))

  //   const links = menuRoot.querySelectorAll(".fw-menu__link[href]")
  //   links.forEach((link) => {
  //     let linkUrl = null
  //     try {
  //       linkUrl = new URL(link.getAttribute("href"), window.location.origin)
  //     } catch (_) {
  //       return
  //     }

  //     const linkTab = linkUrl.searchParams.get("tab")
  //     const matchesTab = linkTab && linkTab === currentTab
  //     const matchesPath = !linkTab && linkUrl.pathname === currentPath
  //     const matchesEntityTeams = linkTab === "teams" && currentPath.includes("entity_teams")

  //     if (matchesTab || matchesPath || matchesEntityTeams) {
  //       const li = link.closest(".fw-menu__item")
  //       if (li) li.classList.add("fw-menu__item--active")
  //     }
  //   })
  // }

  openTeamModal(event) {
    event.preventDefault();

    const action = event.currentTarget.dataset.createDropdownActionParam
    const modal = document.getElementById('selectTeamModal')
    if (modal) {
      const wrapper = modal.closest('[data-controller*="select-team-modal"]')
      if (wrapper) wrapper.dataset.selectTeamModalActionValue = action
      const bsModal = new bootstrap.Modal(modal)
      bsModal.show()
    }
    if (this.hasButtonTarget) this.buttonTarget.click()
  }
}
